import axios from "axios";
import { StatisticsURL } from "../Services";
import { authenticatedHeader, defaultHeader } from "../DefaultConfig";
import { HideAwaiting, ShowAwaiting } from "../../util/Awaiting";

export async function activeAuthorsByTopic(topic: string, days: number) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/statistics/author/active/topic",
    {
      topic: topic,
      days: days,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function activeAuthorsByKeywords(keyword: string, days: number) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/statistics/author/active/keyword",
    {
      keyword: keyword,
      x: days,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function activeAuthorsBySource(source: string, days: number) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/statistics/author/active/source",
    {
      source: source,
      days: days,
    },
    authenticatedHeader()
  );
  HideAwaiting();

  return res.data;
}

export async function findContentWrittenBy(
  author: string,
  source: string,
  days: number
) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/content/view/written-by",
    {
      author: author,
      source: source,
      days: days,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}
